$.ui.dialog.getPositionObject = function (arr) {
    var x = arr[0];
    var y = arr[1];
    return {
        my: "left top",
        at: "left+" + x + " top+" + y,
        of: window,
    };
};

$.widget("ui.dialog", $.ui.dialog, {
    _create: function () {
        if (
            this.options.buttons &&
            Object.values(this.options.buttons).some(Array.isArray)
        ) {
            this.options.buttons = this._fixButtons(this.options.buttons);
        }
        this._super();

        this._addTitlebarButtons();
        this._hideTitlebarButtons();

        this.minZ = this.options.zIndex || 1000;

        // If the maxZ is NaN, reset to minZ
        $.ui.dialog.maxZ = $.ui.dialog.maxZ ? $.ui.dialog.maxZ : this.minZ;
    },
    _fixButtons: function (oldButtons) {
        return Object.entries(oldButtons).reduce(function (acc, entry) {
            var text = entry[0];
            var val = entry[1];
            if (Array.isArray(val)) {
                var id = val[0];
                var isPrimary = !!val[1];
                var onClick = val[2] || function () {};
                return acc.concat({
                    text: text,
                    class: isPrimary
                        ? "el8button el8PrimaryButton ebs-btn ebs-btn-primary"
                        : "el8button el8SecondaryButton ebs-btn ebs-btn-default",
                    id: id,
                    click: onClick,
                });
            } else {
                return acc.concat(
                    Object.assign(val, {
                        text: text,
                    })
                );
            }
        }, []);
    },
    _createWrapper: function () {
        this._super();

        this.uiDialog.css({
            zIndex: this.options.zIndex,
            position: "fixed",
        });
    },
    _createButtons: function () {
        this._super();

        var $buttons = this.uiDialogButtonPane.find("button");

        $buttons
            .wrapAll('<div class="el8DialogButtonContainer actionContainer" />')
            .wrapAll('<ul class="el8ButtonContainer" />');

        $buttons.wrap('<li class="el8ButtonItem" />');

        var $actionContainer = this.uiDialogButtonPane.find(
            ".el8DialogButtonContainer"
        );

        $actionContainer.append($('<span class="tabcatcher" tabindex="0"/>'));
    },
    _title: function (title) {
        if (this.options.title) {
            title.html(this.options.title);
        } else {
            this._super(title);
        }
    },
    _setInitialZIndex: function () {
        // Set a baseline z-index
        var cssZindex = this.uiDialog.css("z-index");
        if (
            cssZindex === null ||
            cssZindex === "auto" ||
            cssZindex < this.minZ
        ) {
            this.uiDialog.css("z-index", this.minZ);
        }
    },
    _moveToTop: function (event, isSilent) {
        this._setInitialZIndex();

        // Setup variables and fetch all open ui dialog z-indices
        var hasMoved = false,
            zIndices = this.uiDialog
                .siblings(".ui-front:visible")
                .map(function () {
                    return +$(this).css("z-index");
                })
                .get(),
            zIndexMax = Math.max.apply(null, zIndices);

        // Find and store the true max Z
        zIndexMax = zIndexMax || this.minZ;
        $.ui.dialog.maxZ = Math.max(this.minZ, zIndexMax, $.ui.dialog.maxZ);

        // if the maxZ is higher than this one, then we need to
        // move to a new maxZ
        if ($.ui.dialog.maxZ >= +this.uiDialog.css("z-index")) {
            $.ui.dialog.maxZ++;
            this.uiDialog.css("z-index", $.ui.dialog.maxZ);
            hasMoved = true;
        }

        // Trigger events
        if (hasMoved && !isSilent) {
            this._trigger("focus", event);
        }

        // return the expected boolean
        return hasMoved;
    },
    _hideTitlebarButtons: function () {
        var self = this,
            options = self.options;

        if (options.disableTitlebarClose) {
            self.uiDialogTitlebarClose.addClass("hide");
        }
        if (options.disableTitlebarMinimize) {
            self.uiDialogTitlebarMin.addClass("hide");
        }
        if (options.disableTitlebarExpand) {
            self.uiDialogTitlebarExpand.addClass("hide");
        }
    },
    _addTitlebarButtons: function () {
        var self = this,
            options = self.options;

        self.uiDialogTitlebarClose = $(
            ".ui-dialog-titlebar-close",
            self.uiDialogTitlebar
        );

        if (options.closeFn && typeof options.closeFn === "function") {
            self.uiDialogTitlebarClose.on("click", function (e) {
                options.closeFn();
            });
        }

        // Add custom titlebar components
        var uiDialogTitlebarExpand = (self.uiDialogTitlebarExpand = $(
            '<a href="#"></a>'
        ))
            .addClass(
                "ui-dialog-titlebar-expand " +
                    "maximizeButton " +
                    "ui-corner-all"
            )
            .attr("role", "button")
            .on("mousedown", function (ev) {
                ev.stopPropagation();
            })
            // TODO Should add click event here
            .on("mouseover", function () {
                uiDialogTitlebarExpand.addClass("ui-state-hover");
            })
            .on("mouseout", function () {
                uiDialogTitlebarExpand.removeClass("ui-state-hover");
            })
            .on("focus", function () {
                uiDialogTitlebarExpand.addClass("ui-state-focus");
            })
            .on("blur", function () {
                uiDialogTitlebarExpand.removeClass("ui-state-focus");
            })
            .appendTo(self.uiDialogTitlebar);

        var uiDialogTitlebarMin = (self.uiDialogTitlebarMin = $(
            '<a href="#"></a>'
        ))
            .addClass("ui-dialog-titlebar-min")
            .attr("role", "button")
            .on("mousedown", function (ev) {
                ev.stopPropagation();
            })
            .on("mouseover", function () {
                uiDialogTitlebarMin.addClass("ui-state-hover");
            })
            .on("mouseout", function () {
                uiDialogTitlebarMin.removeClass("ui-state-hover");
            })
            .on("focus", function () {
                uiDialogTitlebarMin.addClass("ui-state-focus");
            })
            .on("blur", function () {
                uiDialogTitlebarMin.removeClass("ui-state-focus");
            })
            .on("click", function (event) {
                event.preventDefault();
                event.stopPropagation();
                if (options.minimizeFn) {
                    options.minimizeFn();
                }
                self.close(event);
                return false;
            })
            .appendTo(self.uiDialogTitlebar);
    },
    _makeDraggable: function () {
        this._super();
        // Update to set the containment option to parent

        this.uiDialog.draggable("option", {
          containment: [
            -650,
            0,
            $(window).width() - 150,
            $(window).height() - 35,
          ],
        });
    },
    _makeResizable: function (handles) {
        this._super(handles);
        var self = this,
            options = self.options;

        if (options.resizeFn && typeof options.resizeFn === "function") {
            self.on("resize", function () {
                options.resizeFn();
            });
        }
    },
    moveToBottom: function () {
        var self = this,
            options = self.options,
            minZ = null,
            saveScroll;

        $(".ui-dialog:visible").each(function () {
            var thisZ = $(this).css("z-index") || options.zIndex;
            minZ = minZ ? Math.min(minZ, thisZ) : parseInt(thisZ, 10);
        });

        if (self.overlay) {
            self.overlay.$el.css("z-index", minZ ? --minZ : 0);
        }
        saveScroll = {
            scrollTop: self.element.attr("scrollTop"),
            scrollLeft: self.element.attr("scrollLeft"),
        };
        self.uiDialog.css("z-index", minZ ? --minZ : 0);
        self.element.attr(saveScroll);
    },
    adjustSize: function () {
        this._size();
    },
    setDraggable: function (isDraggable) {
        this.uiDialog.draggable("option", "disabled", isDraggable === false);
    },
});
